import type { DefaultOptionType } from "antd/es/select"

/**
 * Removes duplicate options from a select options array, keeping the first occurrence.
 * @param options - Array of select options to deduplicate.
 * @param keyBy - Function that extracts a deduplication key from each option.
 * @returns A new array with duplicates removed.
 */
export const dedupeOptions = (options: DefaultOptionType[], keyBy: (option: DefaultOptionType) => string) => {
	const map = new Map<string, DefaultOptionType>()
	options.forEach((option) => {
		const key = keyBy(option)
		if (!map.has(key)) {
			map.set(key, option)
		}
	})
	return Array.from(map.values())
}

/**
 * Checks whether a value exists among the given select options.
 * @param options - Array of select options to search.
 * @param value - The value to look for. Returns `false` for `null`.
 */
export const hasOption = (options: DefaultOptionType[], value: string | number | null) => {
	if (value === null) {
		return false
	}
	return options.some((option) => String(option.value) === String(value))
}

/**
 * Normalizes a category value for comparison by trimming whitespace and lowercasing.
 * @param value - The category value to normalize. Returns `null` for `null`/`undefined`.
 */
export const normalizeCategoryValue = (value: string | number | null | undefined) => {
	if (value === null || value === undefined) {
		return null
	}

	return String(value).trim().toLowerCase()
}
